export default __webpack_public_path__ + "90e38fc6122a6e3df63af5b894ddb78d.png";